import './ScheduleButton.css';
import React, {useState} from "react"
import axios from "axios";
import {Button, Modal, Spinner } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import trackingCall from "../utils/trackingCall"
import ueIcon from '../assets/UElogo_whiteback.png'

// This is a button component that is more than a button.  It calls a popup, among other things.
// First, it searches for a cookie set by our game platform to see if a user accessed the
// host page via a valid login to the UE Game platform. In the case where the cookie is not found...
// It includes a conditionally rendered modal in it that calls a database query to
// validate a user as a client before granting access to a host calendar.  This validation is
// necessary if the this app is accessed from the ue-main-website rather than from the UE Game
// platform.
//
// This component needs to be refactored.  It has a number of problems.

function getCookie(name) {
    // Look for the cookie from the UE Game Platform
    // Split cookie string and get all individual name=value pairs in an array
    let cookieArr = document.cookie.split(";");

    // Loop through the array elements
    for(let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");

        /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
        if(name === cookiePair[0].trim()) {
            // Decode the cookie value and return
            return decodeURIComponent(cookiePair[1]);
        }
    }
    // Return null if not found
    return null;
}


function validateAccess (emailId, calendarLink, setIsLoaded, handleClose) {

    // Perform validation of email address in client database.  If a value is returned invoke
    // window.open to take user to the hosts calendar.  If a value is not returned,
    // alert the user to the failure.

    let client = {email_id: ""}
    const REACT_APP_ENDPOINT = process.env.REACT_APP_ENDPOINT;
    const requestPath = REACT_APP_ENDPOINT + "/clientLookup"

    axios
    .get(requestPath ,
        {params: { emailId: emailId},
        timeout: 3600})
        .then((res) => {
            client = res.data.pop()
            if (client === undefined) {
                setIsLoaded(true)
                alert("We're sorry.  Your email address '"+emailId+"' is not found in our community database.  Please contact us if you need assistance.")
                return
            }
            window.sessionStorage.setItem('beenVerified', true)  //flag user as verified
            handleClose()
            window.open(calendarLink)
        })
    };


const ScheduleButton = ({firstName, photoLink, calendarLink, availableToPublic}) => {

    // First, check to see if the user logged on via the UE game platform.  They will have an
    // access token cookie

    const cookieFound = getCookie ('accesstoken')  // look for the cookie with AWS access token
    if (!window.sessionStorage.getItem('beenVerified') && cookieFound) {  //if they haven't been verfied already
        window.sessionStorage.setItem('beenVerified', true)
    }

    const { register, handleSubmit, getValues } = useForm();
    const onSubmit = data => console.log();   //  This really needs to be cleaned up.  Opted for
                                              //  for a button click rather than a form submit
                                              //  to invoke validateAccess function.
                                              //  Was still learning / hacking at the time.
                                              //  Still am  :)

    function SchedulePopup () {
        // isLoaded is used for a spinner.  validateAccess sets the status when done.
        const [isLoaded, setIsLoaded] = useState(true);
        const [show, setShow] = useState(false);
        const handleClose = () => setShow(false);
        const handleShow = () => {
            if (window.sessionStorage.getItem('beenVerified')) {  //this test is here for those that
                if (calendarLink ) {                              //that have become verified since
                    window.open(calendarLink)                     //the initial render of the HostSectionConainer
                }                                                 //when the page has not been rerendered since
            }                                                    //Also preventing a missing calendar from opening a new tab.
            else {
                trackingCall('Schedule Button ' + firstName)
                setShow(true)
        }
        }
        return (
        <>
        <Button onClick={handleShow} className="blue-button">Schedule {firstName} Now</Button>
        <Modal contentClassName="popup-content"
            show={show}
            onHide={handleClose}
            size="lg"
            centered="true"
            aria-labelledby="contained-modal-title-vcenter"
            >

        <Modal.Header className="modal-header" closeButton>
        <Modal.Title id="contained-modal-title-vcenter" >
             <img className="small-logo" src={ueIcon} alt={"Utopia Experiences Logo"}/>
            <img className="small-photo" src={photoLink} alt={firstName + " photo"}/>
            <span>   </span> <span>   </span>
            {(!isLoaded) &&
                <Spinner animation="grow"  size="sm" role="status" style={{color: "#00447c"}}>
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
                }
            <span>   </span>
          </Modal.Title>
        </Modal.Header>
            <div className="modal-body">

        {firstName} is exclusively available to members of our Utopia Experiences Care Community.  If you are a current subscriber,
        please enter your Utopia Experiences login email to schedule {firstName} to host your game.  <br/> <br/>
        You can learn more about booking our game show hosts
        by clicking the 'Learn More' button at the top of the 'Hosts' page.   Please feel free to contact us
        for additional information. <br/><br/>

          <form onSubmit={handleSubmit(onSubmit)}>
                <input type="text" size="30" {...register("emailAddress")} required/>
                <br/>
                <Button className="blue-button" type="submit"
                    onClick={() => {
                        trackingCall('Verify Email Button ' + firstName)
                        if (getValues("emailAddress") !== '') {
                            setIsLoaded(false)
                            validateAccess(getValues("emailAddress"), calendarLink, setIsLoaded, handleClose)
                        }
                }}
                >Submit Email Address</Button>
                <Button className="blue-button"
                    href="https://www.utopiaexperiences.net/contact">Contact Us</Button>

            </form>
            </div>
            <br></br>
            <Modal.Footer className="modal-footer">
          <Button className="blue-button" variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
        </Modal>
        </>
        )
    };

    return (
    <div >

        {(window.sessionStorage.getItem('beenVerified') || availableToPublic === 'y') &&
            <Button className="blue-button"
                onClick={() => {
                    window.open(calendarLink)
                    trackingCall('Schedule Button ' + firstName)}
                }
                >Schedule {firstName} Now</Button>}
        {(!window.sessionStorage.getItem('beenVerified') && availableToPublic !== 'y') &&
            <SchedulePopup />}

    </div>
    )
}


export default ScheduleButton